import { Base } from './base.model';

export class SiteVerificationVisit extends Base {
  public siteID: number;
  public date: Date;
  public verificationType: string;
}
